import { render, staticRenderFns } from "./UpOther.vue?vue&type=template&id=62b7a022&scoped=true&"
import script from "./UpOther.vue?vue&type=script&lang=js&"
export * from "./UpOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7a022",
  null
  
)

export default component.exports